module.exports = __webpack_public_path__ + "img/chevron-right.e97d1a79.svg";